import { Modal } from 'newui/components/ui/Modal';

export interface CancelRevisionModalProps {
	isCancelling?: boolean;
	isOpen: boolean;
	/** Optional override for the confirmation body text. */
	message?: string;
	/** Optional override for the dialog heading. */
	title?: string;
	onClose: () => void;
	onConfirm: () => void;
}

/**
 * Confirmation dialog for discarding pending revision changes — either for a
 * single quote table or the entire revision. Wraps the shared newui Modal with
 * a destructive (warning) preset.
 */
const CancelRevisionModal: React.FC<CancelRevisionModalProps> = ({
	isCancelling = false,
	isOpen,
	title,
	message,
	onClose,
	onConfirm,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={title ?? 'Cancel revision changes'}
			iconType="error"
			modalType="standard"
			closeOnEsc
			closeOnOverlayClick
			size="md"
			primaryButton={{
				btntype: 'danger',
				text: isCancelling ? 'Cancelling...' : 'Cancel changes',
				isLoading: isCancelling,
				onClick: onConfirm,
			}}
			secondaryButton={{
				text: 'Keep changes',
				onClick: onClose,
			}}
		>
			<div className="text-center font-roboto text-sm text-tertiary-600">
				{message ? (
					<p>{message}</p>
				) : (
					<>
						<p className="mb-2">
							Are you sure you want to discard your pending revision
							changes?
						</p>
						<p>This will restore the last submitted values and cannot be undone.</p>
					</>
				)}
			</div>
		</Modal>
	);
};

export { CancelRevisionModal };
